import React, { memo, useContext, useMemo } from "react";
import { Redirect, Route as RRoute } from "react-router-dom";
import { CookiesType, getCookie, Role } from "@cyberalarm/common";

import { CommonRoutes } from "./routes";

import { StoreContext, selectors } from "store";

interface AdminRouteProps {
  component: React.ComponentType<any>;
  path: string;
  redirect?: string;
}

const Route = ({
  component: Component,
  redirect = CommonRoutes.root,
  ...rest
}: AdminRouteProps) => {
  const token = getCookie(CookiesType.token);
  const state = useContext(StoreContext);
  const userRole = selectors.getUserRole(state);
  const isUserAdmin = userRole === Role.admin;

  return useMemo(
    () => (
      <RRoute
        {...rest}
        render={(props) =>
          token != null && isUserAdmin ? (
            <Component {...props} />
          ) : (
            <Redirect to={redirect} />
          )
        }
      />
    ),
    [isUserAdmin, redirect, rest, token],
  );
};

export const AdminRoute = memo(Route);
